// src/assets/maps/map1.js
const floor = "░";
const wall = "▓";
const monster = "M";
const item = "I";
const map = `
    ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
    ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
    ▓░░░░░░░░░░░░░░░░▓
    ▓░░░░░░░M░░░░░░░M▓
    ▓░░░░░▓▓▓░░░░░░░▓▓
    ▓░░░░░▓I░░░░▓░░░M▓
    ▓░░░░░░░░░░░░░░░░▓
    ▓░M░░░░░░░░░░░░░░▓
    ▓▓░░░░░░░░░░░░░░░▓
    ▓░M░░░░░░░░M░░░░░▓
    ▓░░░▓▓▓▓▓▓▓▓░░░░░▓
    ▓░░░░░░░░▓I░░░▓░░▓
    ▓░░░░░░░░░░░░░░░░▓
    ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
    ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓
  `;
export default {
  monster,
  floor,
  wall,
  item,
  map,
};
